import { render, staticRenderFns } from "./Scene1.vue?vue&type=template&id=7264eace&scoped=true"
import script from "./Scene1.vue?vue&type=script&lang=js"
export * from "./Scene1.vue?vue&type=script&lang=js"
import style0 from "./Scene1.vue?vue&type=style&index=0&id=7264eace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264eace",
  null
  
)

export default component.exports